import { PhoneDuplicated } from './PhoneDuplicated/PhoneDuplicated';

export const PhoneDuplicatedPage = () => {
  return <PhoneDuplicated />;
};
